/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ecommerce_Amazon_Tools_Execute_Output7Inputs */

const en_svc_ecommerce_amazon_tools_execute_output7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Running tooling`)
};

const ar_svc_ecommerce_amazon_tools_execute_output7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أدوات تعمل`)
};

const bn_svc_ecommerce_amazon_tools_execute_output7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কার্যকর টুলিং`)
};

const de_svc_ecommerce_amazon_tools_execute_output7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktionierendes Tooling`)
};

const es_svc_ecommerce_amazon_tools_execute_output7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Herramientas en marcha`)
};

const fr_svc_ecommerce_amazon_tools_execute_output7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Outillage fonctionnel`)
};

const pt_svc_ecommerce_amazon_tools_execute_output7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ferramentas funcionais`)
};

const zh_svc_ecommerce_amazon_tools_execute_output7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可用工具`)
};

const tr_svc_ecommerce_amazon_tools_execute_output7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çalışan araçlar`)
};

const ru_svc_ecommerce_amazon_tools_execute_output7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рабочие инструменты`)
};

const pl_svc_ecommerce_amazon_tools_execute_output7 = /** @type {(inputs: Svc_Ecommerce_Amazon_Tools_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Działające narzędzia`)
};

/**
* | output |
* | --- |
* | "Running tooling" |
*
* @param {Svc_Ecommerce_Amazon_Tools_Execute_Output7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ecommerce_amazon_tools_execute_output7 = /** @type {((inputs?: Svc_Ecommerce_Amazon_Tools_Execute_Output7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ecommerce_Amazon_Tools_Execute_Output7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ecommerce_amazon_tools_execute_output7(inputs)
	if (locale === "bn") return bn_svc_ecommerce_amazon_tools_execute_output7(inputs)
	if (locale === "de") return de_svc_ecommerce_amazon_tools_execute_output7(inputs)
	if (locale === "es") return es_svc_ecommerce_amazon_tools_execute_output7(inputs)
	if (locale === "fr") return fr_svc_ecommerce_amazon_tools_execute_output7(inputs)
	if (locale === "pt") return pt_svc_ecommerce_amazon_tools_execute_output7(inputs)
	if (locale === "zh") return zh_svc_ecommerce_amazon_tools_execute_output7(inputs)
	if (locale === "tr") return tr_svc_ecommerce_amazon_tools_execute_output7(inputs)
	if (locale === "ru") return ru_svc_ecommerce_amazon_tools_execute_output7(inputs)
	if (locale === "pl") return pl_svc_ecommerce_amazon_tools_execute_output7(inputs)
	return en_svc_ecommerce_amazon_tools_execute_output7(inputs)
});
export { svc_ecommerce_amazon_tools_execute_output7 as "svc_ecommerce-amazon-tools_EXECUTE_output" }